define('modularis/entity/common', {

    AssemblyName: 'Modularis.Entity, Version=17.0.0.0, Culture=neutral, PublicKeyToken=09e34ae349d1185c'

});
